export const oldNameStrategyChoices = [
  { id: "numeric", name: "Numeric" },
  { id: "alphanumeric", name: "Alphanumeric" },
];

export const validNameStrategyChoices = [{ id: "numeric", name: "Numeric" }];
